<template>
  <div class="col-12">
    <div class="app-content">
      <div class="app-title">
        <h1>
          <i class="fa fa-cogs"></i>
          Tiện ích
        </h1>
      </div>

      <tool-contact v-if="['admin', 'owner', 'tech', 'account', 'am'].includes($store.state.user.role)" />
      <filter-email v-if="['admin', 'owner', 'tech', 'account', 'am', 'manager'].includes($store.state.user.role)"  />

      <call-sync v-if="['admin', 'owner', 'tech', 'account', 'am'].includes($store.state.user.role)" />
      <clear-cache v-if="['owner'].includes($store.state.user.role)" />
      <plan-calculator v-if="['admin', 'owner', 'tech', 'account', 'am', 'manager'].includes($store.state.user.role)" />
      <upload-recording v-if="['admin', 'owner', 'tech', 'account', 'am'].includes($store.state.user.role)" />
      <index-search v-if="['admin', 'owner', 'tech'].includes($store.state.user.role)" />
    </div>
  </div>
</template>
<script>
import ToolContact from './Contact';
import FilterEmail from './FilterEmail';
import CallSync from './CallSync';
import ClearCache from './ClearCache';
import IndexSearch from './IndexSearch.vue';
import PlanCalculator from "@/views/tool/PlanCalculator";
import UploadRecording from "@/views/tool/UploadRecording.vue";


export default {
  components: {
    PlanCalculator,
    "tool-contact": ToolContact,
    "filter-email": FilterEmail,
    CallSync,
    ClearCache,
    UploadRecording,
    IndexSearch,
  }
}
</script>
